module.exports = __webpack_public_path__ + "img/84.91d24a54.jpg";